export default {"src":"/_next/static/media/claim-fill.42273ad1.svg","height":16,"width":16};